import { useState, type FormEvent } from 'react';
import { api } from '../lib/api';
import { AuthShell, ErrorBox } from './Login';

// Landing page for the link amada-auth emails (first-time password or a
// forgotten one): /reset?token=… This sets the person's Amada password, the
// one shared by every Amada dashboard. It does not sign them in; they go back
// to the sign-in screen afterwards.
export function ResetPassword({ token }: { token: string }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (password.length < 8) { setError('Use at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords don\'t match.'); return; }
    setError(null); setBusy(true);
    try {
      await api('/api/auth/reset-password', { method: 'POST', body: { token, password } });
      setDone(true);
      // Drop the one-time token from the address bar.
      window.history.replaceState(null, '', '/');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not set password');
    } finally { setBusy(false); }
  };

  return (
    <AuthShell>
      <h1 style={{ margin: '0 0 6px', fontSize: 20, fontWeight: 600 }}>Set your Amada password</h1>
      <div className="muted" style={{ fontSize: 13, marginBottom: 18 }}>
        This is your Amada login password, the same one the other Amada dashboards use.
      </div>

      {done ? (
        <div>
          <div style={{ fontSize: 14 }}>Password saved. Sign in with your email and new password.</div>
          <button className="btn btn-primary" style={{ marginTop: 16 }} onClick={() => { window.location.href = '/'; }}>
            Go to sign in
          </button>
        </div>
      ) : (
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <label className="form-lbl">New password (min 8 chars)</label>
          <input className="input" type="password" autoComplete="new-password" autoFocus required minLength={8} value={password} onChange={e => setPassword(e.target.value)} />
          <label className="form-lbl">Confirm</label>
          <input className="input" type="password" autoComplete="new-password" required minLength={8} value={confirm} onChange={e => setConfirm(e.target.value)} />
          {error && <ErrorBox text={error} />}
          <button className="btn btn-primary" disabled={busy} style={{ height: 36, marginTop: 6 }}>
            {busy ? 'Saving…' : 'Save password'}
          </button>
          <button type="button" className="btn btn-ghost" style={{ height: 'auto', padding: '4px 0', borderColor: 'transparent', fontSize: 12.5, alignSelf: 'flex-start' }}
            onClick={() => { window.location.href = '/'; }}>
            ← Back to sign in
          </button>
        </form>
      )}
    </AuthShell>
  );
}
